import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { QuickAccessDeviceQuery, QuickAccessDeviceQueryVariables } from '@/shared/api';
import QUICK_ACCESS_DEVICE_QUERY from '../queries/quickAccessDevice';

/**
 * Loads the quick-access details of a single device. Runs the quickAccessDevice query for the device id and throws the first GraphQL error only when nothing came back.
 *
 * @param deviceId - Identifier of the device to load.
 * @returns A promise resolving to the quick-access device payload.
 */
const fetchQuickAccessDevice = async (deviceId: any) => {
  const client = createClient();
  const result = await client.query<QuickAccessDeviceQuery, QuickAccessDeviceQueryVariables>({
    query: QUICK_ACCESS_DEVICE_QUERY,
    variables: {
      deviceId,
    },
  });
  const { data, errors } = result;
  const { quickAccessDevice } = data;

  if (_.isNil(quickAccessDevice) && errors?.length) {
    throw new Error(errors[0].message);
  }

  return quickAccessDevice;
};

export default fetchQuickAccessDevice;
